import { useTranslation } from '@/hooks/useTranslation';
import React from 'react';

interface VoteButtonProps {
  hasVoted: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const VoteButton: React.FC<VoteButtonProps> = ({
  hasVoted,
  onClick,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      className={`
        flex-shrink-0 px-4 py-2 text-sm font-normal rounded border
        transition-colors flex items-center gap-2
        ${hasVoted ? 'bg-blue-700 text-white' : 'bg-transparent text-blue-700'}
        border-blue-700
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
      aria-label={
        hasVoted
          ? t('voting.removeFavoriteAriaLabel')
          : t('voting.favoriteAriaLabel')
      }
      aria-pressed={hasVoted}
    >
      <i className='pi pi-thumbs-up text-sm' />
      <span>{t('voting.vote', { defaultValue: 'Vote' })}</span>
    </button>
  );
};

export default VoteButton;
